export default {
    'edit-account': 'تعديل الحساب',
    'delete-account': 'حذف الحساب',

    'account-type': {
        title: 'نوع الحساب',
        main: 'أساسي',
        sub: 'فرعي',
    },
    
    'account-category': 'تصنيف الحساب:',
    
    'final-accounts': {
        title: 'الحساب الختامي',
        operations: 'تشغيل',
        trade: 'مُتاجرة',
        'gains-and-losses': 'أرباح وخسائر',
        budget: 'ميزانية',
    },

    'max-credit-amount': 'سقف الدائن',
    'max-debit-amount': 'سقف المدين',
    'debt-is-forbidden': 'ممنوع من الدين',
    yes: 'نعم',
    no: 'لا',

    'contect-info': {
        'phone-number': 'رقم الهاتف',
        'mobile-number': 'رقم الجوال',
        email: 'البريد الإلكتروني',
        address: 'العنوان',
    },
    
    notes: 'الملاحظات',
    
    'account-statement': 'كشف حساب',
    'breakdown-of-the-total-by-currency': 'تفصيل المجموع حسب العملات',
    
    'delete-the-account': 'حذف الحساب',
    'are-you-sure-you-want-to-delete-the-account-$': 'هل أنت متأكد من حذف حساب {accountName}؟',

    headers: {
        'sum-debits': 'مجموع مدين',
        'sum-credits': 'مجموع دائن',
        balance: 'الرصيد',
        'equivalent-currency': 'عملة مكافئة',
        'currency-equivalent': 'المكافئ بالعملة',
        'currencies-balances': 'أرصدة العملات',
    },

    'sum-currencies-result-headers': {
        'currency-debits': 'عملات مدينة',
        'currency-credits': 'عملات دائنة',
    }
}